<template>
  <div id="app">
    <DisplayPayload :language_abbr="language_abbr"/>
  </div>
</template>

<script>
import DisplayPayload from './components/DisplayPayload'
export default {
  components: { DisplayPayload },
  created() {
    this.setLanguage()
  },
  data() {
    return {
      language_abbr: 'en'
    }
  },
  methods: {
    setLanguage() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      const langs = ['en', 'de', 'es', 'fr', 'it', 'nl', 'se'];
      const abbrLang = (params.language || 'en').split('-')[0]
      this.language_abbr = langs.includes(abbrLang) ? abbrLang : 'en';
    }
  }
}
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import 'bootstrap/dist/css/bootstrap.css';
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  @import '@/assets/styles/styles.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue